module.exports = __webpack_public_path__ + "img/down.5c51ddfb.svg";